var global = window

var arrMois = Array('Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre');

// ================== Converti le texte Word en propre ====================================================
global.convertWord = function (content) {
    // Converti en \n
    content = content.replace(/\n/g, "");
    content = content.replace(/<\/tr>/g, "\n");
    content = content.replace(/<\/TR>/g, "\n");
    content = content.replace(/<br>/g, "\n");
    content = content.replace(/<BR>/g, "\n");
    content = content.replace(/<br \/>/g, "\n");
    content = content.replace(/<BR \/>/g, "\n");

    // Protege les bons
    content = content.replace(/<strong>/g, "|strong|");
    content = content.replace(/<\/strong>/g, "|/strong|");
    content = content.replace(/<em>/g, "|em|");
    content = content.replace(/<\/em>/g, "|/em|");
    content = content.replace(/<p>/g, "|p|");
    content = content.replace(/<\/p>/g, "|/p|");

    // On se débarasse des sales '
    content = content.replace(/&rsquo;/g, "'");
    content = content.replace(/&lsquo;/g, "'");

    var newString = "";
    var inTag = false;
    for (var i = 0; i < content.length; i++) {

        if (content.charAt(i) == '<') inTag = true;
        if (content.charAt(i) == '>') {
            if (content.charAt(i + 1) == "<") {
                //dont do anything
            }
            else {
                inTag = false;
                i++;
            }
        }

        if (!inTag) newString += content.charAt(i);

    }

    // Remet les bons
    content = newString.replace(/\n/g, "<br />");
    content = content.replace(/\|strong\|/g, "<strong>");
    content = content.replace(/\|\/strong\|/g, "</strong>");
    content = content.replace(/\|em\|/g, "<em>");
    content = content.replace(/\|\/em\|/g, "</em>");
    content = content.replace(/\|p\|/g, "<p>");
    content = content.replace(/\|\/p\|/g, "</p>");


    return content;
}

// ================== Transforme une date en texte
global.dateToText = function (obj) {
    var date = obj.value;

    // On remet en ordre
    tmp = date.split("-");
    date = tmp[2] + arrMois[parseFloat(tmp[1])] + tmp[0];

    obj.value = date;
    if (obj.innerHTML) {
        obj.innerHTML = date;
    } else {
        obj.setAttribute("innerHTML", date);
    }
}


// This code was written by Tyler Akins and has been placed in the
// public domain.  It would be nice if you left this header intact.
// Base64 code from Tyler Akins -- http://rumkin.com
var keyStr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";

global.encode64 = function (input) {
    var output = "";
    var chr1, chr2, chr3;
    var enc1, enc2, enc3, enc4;
    var i = 0;

    while (i < input.length) {
        chr1 = input.charCodeAt(i++);
        chr2 = input.charCodeAt(i++);
        chr3 = input.charCodeAt(i++);

        enc1 = chr1 >> 2;
        enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
        enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
        enc4 = chr3 & 63;

        if (isNaN(chr2)) {
            enc3 = enc4 = 64;
        } else if (isNaN(chr3)) {
            enc4 = 64;
        }

        output += keyStr.charAt(enc1) + keyStr.charAt(enc2) + keyStr.charAt(enc3) + keyStr.charAt(enc4);
    }

    return output;
}

global.decode64 = function (input) {
    var output = "";
    var chr1, chr2, chr3;
    var enc1, enc2, enc3, enc4;
    var i = 0;

    // remove all characters that are not A-Z, a-z, 0-9, +, /, or =
    input = input.replace(/[^A-Za-z0-9\+\/\=]/g, "");

    while (i < input.length) {
        enc1 = keyStr.indexOf(input.charAt(i++));
        enc2 = keyStr.indexOf(input.charAt(i++));
        enc3 = keyStr.indexOf(input.charAt(i++));
        enc4 = keyStr.indexOf(input.charAt(i++));

        chr1 = (enc1 << 2) | (enc2 >> 4);
        chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
        chr3 = ((enc3 & 3) << 6) | enc4;

        output += String.fromCharCode(chr1);

        if (enc3 != 64) {
            output += String.fromCharCode(chr2);
        }
        if (enc4 != 64) {
            output += String.fromCharCode(chr3);
        }
    }

    return output;
}

// ================== Formatte une date en texte ===================================================
global.formatDate = function (date) {
    var currentYear = new Date().getFullYear();
    var date = date.split("-");

    return date[2] + " " + arrMois[date[1] - 1] + ((currentYear != date[0]) ? " " + date[0] : '');
}

global.getJsonFromUrl = function (url) {
  if(!url) url = location.href;
  var question = url.indexOf("?");
  var hash = url.indexOf("#");
  if(hash==-1 && question==-1) return {};
  if(hash==-1) hash = url.length;
  var query = question==-1 || hash==question+1 ? url.substring(hash) :
  url.substring(question+1,hash);
  var result = {};
  query.split("&").forEach(function(part) {
    if(!part) return;
    part = part.split("+").join(" "); // replace every + with space, regexp-free version
    var eq = part.indexOf("=");
    var key = eq>-1 ? part.substr(0,eq) : part;
    if (key) {
        var val = eq > -1 ? decodeURIComponent(part.substr(eq + 1)) : "";
        var from = key.indexOf("[");
        if (from == -1) result[decodeURIComponent(key)] = val;
        else {
            var to = key.indexOf("]", from);
            var index = decodeURIComponent(key.substring(from + 1, to));
            key = decodeURIComponent(key.substring(0, from));
            if (!result[key]) result[key] = [];
            if (!index) result[key].push(val);
            else result[key][index] = val;
        }
    }
  });
  return result;
}

global.dateYMD = function (date) {
    // Obtention des composants de la date
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');

    // Formatage de la date au format Y-m-d
    return `${year}-${month}-${day}`;
}

// ================== Vérifie si c'est un nombre =====================================================
global.isNumber = function (champ) {
    var re = /^[0-9-'.'-',']*$/;
    if (!re.test(champ.value)) {
        champ.value = champ.value.replace(/[^0-9-'.'-',']/g, "");
    }
}

// ==================== Converti une valeur en valeur monétaire
global.roundTo = function (n, digits) {
    var negative = false;
    if (digits === undefined) {
        digits = 0;
    }
    if( n < 0) {
        negative = true;
        n = n * -1;
    }
    var multiplicator = Math.pow(10, digits);
    n = parseFloat((n * multiplicator).toFixed(11));
    n = (Math.round(n) / multiplicator).toFixed(digits);
    if( negative ) {
        n = (n * -1).toFixed(digits);
    }
    return n;
}

global.money_format = function (value) {
    value = parseFloat(roundTo(value, 3));

    var testPoint = value.toString().split(".");
    if (testPoint.length > 1) {
        if (testPoint[1].length == 1) {
            return value + "0";
        } else {
            return value;
        }
    }

    // si ya pas de point, on commence
    if (value * 100 == Math.floor(value * 100)) {
        return value + ".00";
    } else if (value * 10 == Math.floor(value * 10)) {
        return value + "0";
    }
    return value;
}

global.number_format = function (number, decimals, decPoint, thousandsSep) {
    number = (number + '').replace(/[^0-9+\-Ee.]/g, '')
    var n = !isFinite(+number) ? 0 : +number
    var prec = !isFinite(+decimals) ? 0 : Math.abs(decimals)
    var sep = (typeof thousandsSep === 'undefined') ? ',' : thousandsSep
    var dec = (typeof decPoint === 'undefined') ? '.' : decPoint
    var s = ''

    var toFixedFix = function (n, prec) {
        if (('' + n).indexOf('e') === -1) {
            return +(Math.round(n + 'e+' + prec) + 'e-' + prec)
        } else {
            var arr = ('' + n).split('e')
            var sig = ''
            if (+arr[1] + prec > 0) {
                sig = '+'
            }
            return (+(Math.round(+arr[0] + 'e' + sig + (+arr[1] + prec)) + 'e-' + prec)).toFixed(prec)
        }
    }

    s = (prec ? toFixedFix(n, prec).toString() : '' + Math.round(n)).split('.')
    if (s[0].length > 3) {
        s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep)
    }
    if ((s[1] || '').length < prec) {
        s[1] = s[1] || ''
        s[1] += new Array(prec - s[1].length + 1).join('0')
    }

    return s.join(dec)
}

global.money_formating = function ($format, $money, $thousands) {
    if ($thousands === undefined) $thousands = true;
    return number_format($money, 2, ".", ($thousands)?"&nbsp;":'');
}

global.formatMoney = function ($number, $unit, $thousands) {
    if ($unit === undefined) $unit = '$';
    if ($thousands === undefined) $thousands = true;
    let $formatedNumber = money_formating("%.2n", $number, $thousands) + (($unit) ? '&nbsp;' + $unit : '');
    if ($number < 0) {
        return '<span class="negative">(' + $formatedNumber + ')</span>';
    }
    return $formatedNumber;
}

global.parseNumber = function (str) {
    let isNegative = /^\s*\(.*\)\s*$/.test(str); // vérifie si str est entouré de parenthèses
    let cleaned = str.replace(/[^\d.-]+/g, "");  // supprime tout sauf chiffres, . et -
    let result = parseFloat(cleaned);

    if (isNaN(result)) return NaN;
    return isNegative ? -Math.abs(result) : result;
}

// ========================= Transforme du texte en date
global.textToDate = function (obj) {
    var date = obj.getAttribute("value");
    if (!date) {
        date = obj.innerHTML;
    }

    // On change les mois
    date = date.replace(/ janvier /g, '-01-');
    date = date.replace(/ février /g, '-02-');
    date = date.replace(/ mars /g, '-03-');
    date = date.replace(/ avril /g, '-04-');
    date = date.replace(/ mai /g, '-05-');
    date = date.replace(/ juin /g, '-06-');
    date = date.replace(/ juillet /g, '-07-');
    date = date.replace(/ août /g, '-08-');
    date = date.replace(/ septembre /g, '-09-');
    date = date.replace(/ octobre /g, '-10-');
    date = date.replace(/ novembre /g, '-11-');
    date = date.replace(/ décembre /g, '-12-');

    // On remet en ordre
    tmp = date.split("-");
    date = tmp[2] + "-" + tmp[1] + "-" + tmp[0];

    obj.setAttribute("value", date);
    if (obj.innerHTML) {
        obj.innerHTML = date;
    }
}

// ======================= Encode une chaîne ============================================
global.htmlentities = function (texte) {
    // On en profite pour nettoyer les débuts et fins
    while (texte.charCodeAt(0) == 10 || texte.charCodeAt(0) == 9) {
        texte = texte.substr(1);
    }
    while (texte.charCodeAt(texte.length - 1) == 10 || texte.charCodeAt(texte.length - 1) == 9 || texte.charCodeAt(texte.length - 1) == 32) {
        texte = texte.substr(0, texte.length - 1);
    }

    texte = texte.replace(/"/g, '&quot;'); // 34 22
    texte = texte.replace(/&/g, '&amp;'); // 38 26
    texte = texte.replace(/\'/g, '&#39;'); // 39 27
    texte = texte.replace(/</g, '&lt;'); // 60 3C
    texte = texte.replace(/>/g, '&gt;'); // 62 3E
    texte = texte.replace(/\^/g, '&circ;'); // 94 5E
    texte = texte.replace(//g, '&lsquo;'); // 145 91
    texte = texte.replace(//g, '&rsquo;'); // 146 92
    texte = texte.replace(//g, '&ldquo;'); // 147 93
    texte = texte.replace(//g, '&rdquo;'); // 148 94
    texte = texte.replace(//g, '&bull;'); // 149 95
    texte = texte.replace(//g, '&ndash;'); // 150 96
    texte = texte.replace(//g, '&mdash;'); // 151 97
    texte = texte.replace(//g, '&tilde;'); // 152 98
    texte = texte.replace(//g, '&trade;'); // 153 99
    texte = texte.replace(//g, '&scaron;'); // 154 9A
    texte = texte.replace(//g, '&rsaquo;'); // 155 9B
    texte = texte.replace(//g, '&oelig;'); // 156 9C
    texte = texte.replace(//g, '&#357;'); // 157 9D
    texte = texte.replace(//g, '&#382;'); // 158 9E
    texte = texte.replace(//g, '&Yuml;'); // 159 9F
    texte = texte.replace(/ /g, '&nbsp;'); // 160 A0
    texte = texte.replace(/Ą/g, '&iexcl;'); // 161 A1
    texte = texte.replace(/˘/g, '&cent;'); // 162 A2
    texte = texte.replace(/Ł/g, '&pound;'); // 163 A3
    texte = texte.replace(/¤/g, '&curren;'); // 164 A4
    texte = texte.replace(/Ľ/g, '&yen;'); // 165 A5
    texte = texte.replace(/Ś/g, '&brvbar;'); // 166 A6
    texte = texte.replace(/§/g, '&sect;'); // 167 A7
    texte = texte.replace(/¨/g, '&uml;'); // 168 A8
    texte = texte.replace(/Š/g, '&copy;'); // 169 A9
    texte = texte.replace(/Ş/g, '&ordf;'); // 170 AA
    texte = texte.replace(/Ť/g, '&laquo;'); // 171 AB
    texte = texte.replace(/Ź/g, '&not;'); // 172 AC
    texte = texte.replace(/­/g, '&shy;'); // 173 AD
    texte = texte.replace(/Ž/g, '&reg;'); // 174 AE
    texte = texte.replace(/Ż/g, '&macr;'); // 175 AF
    texte = texte.replace(/°/g, '&deg;'); // 176 B0
    texte = texte.replace(/ą/g, '&plusmn;'); // 177 B1
    texte = texte.replace(/˛/g, '&sup2;'); // 178 B2
    texte = texte.replace(/ł/g, '&sup3;'); // 179 B3
    texte = texte.replace(/´/g, '&acute;'); // 180 B4
    texte = texte.replace(/ľ/g, '&micro;'); // 181 B5
    texte = texte.replace(/ś/g, '&para'); // 182 B6
    texte = texte.replace(/ˇ/g, '&middot;'); // 183 B7
    texte = texte.replace(/¸/g, '&cedil;'); // 184 B8
    texte = texte.replace(/š/g, '&sup1;'); // 185 B9
    texte = texte.replace(/ş/g, '&ordm;'); // 186 BA
    texte = texte.replace(/ť/g, '&raquo;'); // 187 BB
    texte = texte.replace(/ź/g, '&frac14;'); // 188 BC
    texte = texte.replace(/˝/g, '&frac12;'); // 189 BD
    texte = texte.replace(/ž/g, '&frac34;'); // 190 BE
    texte = texte.replace(/ż/g, '&iquest;'); // 191 BF
    texte = texte.replace(/Ŕ/g, '&Agrave;'); // 192 C0
    texte = texte.replace(/Á/g, '&Aacute;'); // 193 C1
    texte = texte.replace(/Â/g, '&Acirc;'); // 194 C2
    texte = texte.replace(/Ă/g, '&Atilde;'); // 195 C3
    texte = texte.replace(/Ä/g, '&Auml;'); // 196 C4
    texte = texte.replace(/Ĺ/g, '&Aring;'); // 197 C5
    texte = texte.replace(/Ć/g, '&AElig;'); // 198 C6
    texte = texte.replace(/Ç/g, '&Ccedil;'); // 199 C7
    texte = texte.replace(/Č/g, '&Egrave;'); // 200 C8
    texte = texte.replace(/É/g, '&Eacute;'); // 201 C9
    texte = texte.replace(/Ę/g, '&Ecirc;'); // 202 CA
    texte = texte.replace(/Ë/g, '&Euml;'); // 203 CB
    texte = texte.replace(/Ě/g, '&Igrave;'); // 204 CC
    texte = texte.replace(/Í/g, '&Iacute;'); // 205 CD
    texte = texte.replace(/Î/g, '&Icirc;'); // 206 CE
    texte = texte.replace(/Ď/g, '&Iuml;'); // 207 CF
    texte = texte.replace(/Đ/g, '&ETH;'); // 208 D0
    texte = texte.replace(/Ń/g, '&Ntilde;'); // 209 D1
    texte = texte.replace(/Ň/g, '&Ograve;'); // 210 D2
    texte = texte.replace(/Ó/g, '&Oacute;'); // 211 D3
    texte = texte.replace(/Ô/g, '&Ocirc;'); // 212 D4
    texte = texte.replace(/Ő/g, '&Otilde;'); // 213 D5
    texte = texte.replace(/Ö/g, '&Ouml;'); // 214 D6
    texte = texte.replace(/×/g, '&times;'); // 215 D7
    texte = texte.replace(/Ř/g, '&Oslash;'); // 216 D8
    texte = texte.replace(/Ů/g, '&Ugrave;'); // 217 D9
    texte = texte.replace(/Ú/g, '&Uacute;'); // 218 DA
    texte = texte.replace(/Ű/g, '&Ucirc;'); // 219 DB
    texte = texte.replace(/Ü/g, '&Uuml;'); // 220 DC
    texte = texte.replace(/Ý/g, '&Yacute;'); // 221 DD
    texte = texte.replace(/Ţ/g, '&THORN;'); // 222 DE
    texte = texte.replace(/ß/g, '&szlig;'); // 223 DF
    texte = texte.replace(/ŕ/g, '&agrave;'); // 224 E0
    texte = texte.replace(/á/g, '&aacute;'); // 225 E1
    texte = texte.replace(/â/g, '&acirc;'); // 226 E2
    texte = texte.replace(/ă/g, '&atilde;'); // 227 E3
    texte = texte.replace(/ä/g, '&auml;'); // 228 E4
    texte = texte.replace(/ĺ/g, '&aring;'); // 229 E5
    texte = texte.replace(/ć/g, '&aelig;'); // 230 E6
    texte = texte.replace(/ç/g, '&ccedil;'); // 231 E7
    texte = texte.replace(/č/g, '&egrave;'); // 232 E8
    texte = texte.replace(/é/g, '&eacute;'); // 233 E9
    texte = texte.replace(/ę/g, '&ecirc;'); // 234 EA
    texte = texte.replace(/ë/g, '&euml;'); // 235 EB
    texte = texte.replace(/ě/g, '&igrave;'); // 236 EC
    texte = texte.replace(/í/g, '&iacute;'); // 237 ED
    texte = texte.replace(/î/g, '&icirc;'); // 238 EE
    texte = texte.replace(/ď/g, '&iuml;'); // 239 EF
    texte = texte.replace(/đ/g, '&eth;'); // 240 F0
    texte = texte.replace(/ń/g, '&ntilde;'); // 241 F1
    texte = texte.replace(/ň/g, '&ograve;'); // 242 F2
    texte = texte.replace(/ó/g, '&oacute;'); // 243 F3
    texte = texte.replace(/ô/g, '&ocirc;'); // 244 F4
    texte = texte.replace(/ő/g, '&otilde;'); // 245 F5
    texte = texte.replace(/ö/g, '&ouml;'); // 246 F6
    texte = texte.replace(/÷/g, '&divide;'); // 247 F7
    texte = texte.replace(/ř/g, '&oslash;'); // 248 F8
    texte = texte.replace(/ů/g, '&ugrave;'); // 249 F9
    texte = texte.replace(/ú/g, '&uacute;'); // 250 FA
    texte = texte.replace(/ű/g, '&ucirc;'); // 251 FB
    texte = texte.replace(/ü/g, '&uuml;'); // 252 FC
    texte = texte.replace(/ý/g, '&yacute;'); // 253 FD
    texte = texte.replace(/ţ/g, '&thorn;'); // 254 FE
    texte = texte.replace(/˙/g, '&yuml;'); // 255 FF
    texte = texte.replace(/\n/g, '<br />'); // 255 FF
    return texte;
}

/* deprecated */
global.HTMLentities = function (texte) {
    return htmlentities(texte);
}

// ========================= Décode une chaîne ========================================
global.html_entity_decode = function (texte) {
    texte = texte.replace(/&quot;/g, '"'); // 34 22
    texte = texte.replace(/&amp;/g, '&'); // 38 26
    texte = texte.replace(/&#39;/g, "'"); // 39 27
    texte = texte.replace(/&lt;/g, '<'); // 60 3C
    texte = texte.replace(/&gt;/g, '>'); // 62 3E
    texte = texte.replace(/&circ;/g, '^'); // 94 5E
    texte = texte.replace(/&lsquo;/g, ''); // 145 91
    texte = texte.replace(/&rsquo;/g, ''); // 146 92
    texte = texte.replace(/&ldquo;/g, ''); // 147 93
    texte = texte.replace(/&rdquo;/g, ''); // 148 94
    texte = texte.replace(/&bull;/g, ''); // 149 95
    texte = texte.replace(/&ndash;/g, ''); // 150 96
    texte = texte.replace(/&mdash;/g, ''); // 151 97
    texte = texte.replace(/&tilde;/g, ''); // 152 98
    texte = texte.replace(/&trade;/g, ''); // 153 99
    texte = texte.replace(/&scaron;/g, ''); // 154 9A
    texte = texte.replace(/&rsaquo;/g, ''); // 155 9B
    texte = texte.replace(/&oelig;/g, ''); // 156 9C
    texte = texte.replace(/&#357;/g, ''); // 157 9D
    texte = texte.replace(/&#382;/g, ''); // 158 9E
    texte = texte.replace(/&Yuml;/g, ''); // 159 9F
    texte = texte.replace(/&nbsp;/g, ' '); // 160 A0
    texte = texte.replace(/&iexcl;/g, 'Ą'); // 161 A1
    texte = texte.replace(/&cent;/g, '˘'); // 162 A2
    texte = texte.replace(/&pound;/g, 'Ł'); // 163 A3
    texte = texte.replace(/&curren;/g, '¤'); // 164 A4
    texte = texte.replace(/&yen;/g, 'Ľ'); // 165 A5
    texte = texte.replace(/&brvbar;/g, 'Ś'); // 166 A6
    texte = texte.replace(/&sect;/g, '§'); // 167 A7
    texte = texte.replace(/&uml;/g, '¨'); // 168 A8
    texte = texte.replace(/&copy;/g, 'Š'); // 169 A9
    texte = texte.replace(/&ordf;/g, 'Ş'); // 170 AA
    texte = texte.replace(/&laquo;/g, '«'); // 171 AB
    texte = texte.replace(/&not;/g, 'Ź'); // 172 AC
    texte = texte.replace(/&shy;/g, '­'); // 173 AD
    texte = texte.replace(/&reg;/g, 'Ž'); // 174 AE
    texte = texte.replace(/&macr;/g, 'Ż'); // 175 AF
    texte = texte.replace(/&deg;/g, '°'); // 176 B0
    texte = texte.replace(/&plusmn;/g, 'ą'); // 177 B1
    texte = texte.replace(/&sup2;/g, '˛'); // 178 B2
    texte = texte.replace(/&sup3;/g, 'ł'); // 179 B3
    texte = texte.replace(/&acute;/g, '´'); // 180 B4
    texte = texte.replace(/&micro;/g, 'ľ'); // 181 B5
    texte = texte.replace(/&para/g, 'ś'); // 182 B6
    texte = texte.replace(/&middot;/g, 'ˇ'); // 183 B7
    texte = texte.replace(/&cedil;/g, '¸'); // 184 B8
    texte = texte.replace(/&sup1;/g, 'š'); // 185 B9
    texte = texte.replace(/&ordm;/g, 'ş'); // 186 BA
    texte = texte.replace(/&raquo;/g, '»'); // 187 BB
    texte = texte.replace(/&frac14;/g, 'ź'); // 188 BC
    texte = texte.replace(/&frac12;/g, '˝'); // 189 BD
    texte = texte.replace(/&frac34;/g, 'ž'); // 190 BE
    texte = texte.replace(/&iquest;/g, 'ż'); // 191 BF
    texte = texte.replace(/&Agrave;/g, 'À'); // 192 C0
    texte = texte.replace(/&Aacute;/g, 'Á'); // 193 C1
    texte = texte.replace(/&Acirc;/g, 'Â'); // 194 C2
    texte = texte.replace(/&Atilde;/g, 'Ă'); // 195 C3
    texte = texte.replace(/&Auml;/g, 'Ä'); // 196 C4
    texte = texte.replace(/&Aring;/g, 'Ĺ'); // 197 C5
    texte = texte.replace(/&AElig;/g, 'Ć'); // 198 C6
    texte = texte.replace(/&Ccedil;/g, 'Ç'); // 199 C7
    texte = texte.replace(/&Egrave;/g, 'È'); // 200 C8
    texte = texte.replace(/&Eacute;/g, 'É'); // 201 C9
    texte = texte.replace(/&Ecirc;/g, 'Ê'); // 202 CA
    texte = texte.replace(/&Euml;/g, 'Ë'); // 203 CB
    texte = texte.replace(/&Igrave;/g, 'Ì'); // 204 CC
    texte = texte.replace(/&Iacute;/g, 'Í'); // 205 CD
    texte = texte.replace(/&Icirc;/g, 'Î'); // 206 CE
    texte = texte.replace(/&Iuml;/g, 'Ď'); // 207 CF
    texte = texte.replace(/&ETH;/g, 'Đ'); // 208 D0
    texte = texte.replace(/&Ntilde;/g, 'Ń'); // 209 D1
    texte = texte.replace(/&Ograve;/g, 'Ò'); // 210 D2
    texte = texte.replace(/&Oacute;/g, 'Ó'); // 211 D3
    texte = texte.replace(/&Ocirc;/g, 'Ô'); // 212 D4
    texte = texte.replace(/&Otilde;/g, 'Ő'); // 213 D5
    texte = texte.replace(/&Ouml;/g, 'Ö'); // 214 D6
    texte = texte.replace(/&times;/g, '×'); // 215 D7
    texte = texte.replace(/&Oslash;/g, 'Ř'); // 216 D8
    texte = texte.replace(/&Ugrave;/g, 'Ù'); // 217 D9
    texte = texte.replace(/&Uacute;/g, 'Ú'); // 218 DA
    texte = texte.replace(/&Ucirc;/g, 'Ű'); // 219 DB
    texte = texte.replace(/&Uuml;/g, 'Ü'); // 220 DC
    texte = texte.replace(/&Yacute;/g, 'Ý'); // 221 DD
    texte = texte.replace(/&THORN;/g, 'Ţ'); // 222 DE
    texte = texte.replace(/&szlig;/g, 'ß'); // 223 DF
    texte = texte.replace(/&agrave;/g, 'à'); // 224 E0
    texte = texte.replace(/&aacute;/g, 'á'); // 225 E1
    texte = texte.replace(/&acirc;/g, 'â'); // 226 E2
    texte = texte.replace(/&atilde;/g, 'ă'); // 227 E3
    texte = texte.replace(/&auml;/g, 'ä'); // 228 E4
    texte = texte.replace(/&aring;/g, 'ĺ'); // 229 E5
    texte = texte.replace(/&aelig;/g, 'ć'); // 230 E6
    texte = texte.replace(/&ccedil;/g, 'ç'); // 231 E7
    texte = texte.replace(/&egrave;/g, 'è'); // 232 E8
    texte = texte.replace(/&eacute;/g, 'é'); // 233 E9
    texte = texte.replace(/&ecirc;/g, 'ê'); // 234 EA
    texte = texte.replace(/&euml;/g, 'ë'); // 235 EB
    texte = texte.replace(/&igrave;/g, 'ì'); // 236 EC
    texte = texte.replace(/&iacute;/g, 'í'); // 237 ED
    texte = texte.replace(/&icirc;/g, 'î'); // 238 EE
    texte = texte.replace(/&iuml;/g, 'ď'); // 239 EF
    texte = texte.replace(/&eth;/g, 'đ'); // 240 F0
    texte = texte.replace(/&ntilde;/g, 'ń'); // 241 F1
    texte = texte.replace(/&ograve;/g, 'ò'); // 242 F2
    texte = texte.replace(/&oacute;/g, 'ó'); // 243 F3
    texte = texte.replace(/&ocirc;/g, 'ô'); // 244 F4
    texte = texte.replace(/&otilde;/g, 'ő'); // 245 F5
    texte = texte.replace(/&ouml;/g, 'ö'); // 246 F6
    texte = texte.replace(/&divide;/g, '÷'); // 247 F7
    texte = texte.replace(/&oslash;/g, 'ř'); // 248 F8
    texte = texte.replace(/&ugrave;/g, 'ù'); // 249 F9
    texte = texte.replace(/&uacute;/g, 'ú'); // 250 FA
    texte = texte.replace(/&ucirc;/g, 'ű'); // 251 FB
    texte = texte.replace(/&uuml;/g, 'ü'); // 252 FC
    texte = texte.replace(/&yacute;/g, 'ý'); // 253 FD
    texte = texte.replace(/&thorn;/g, 'ţ'); // 254 FE
    texte = texte.replace(/&yuml;/g, '˙'); // 255 FF
    //texte = texte.replace(/<br>/g,'\n'); // 255 FF
    //texte = texte.replace(/<br \/>/g,'\n'); // 255 FF
    texte = texte.replace(/&nbsp;/g, ' '); // 255 FF

    // On en profite pour nettoyer les débuts et fins
    while (texte.charCodeAt(0) == 10 || texte.charCodeAt(0) == 9) {
        texte = texte.substr(1);
    }
    while (texte.charCodeAt(texte.length - 1) == 10 || texte.charCodeAt(texte.length - 1) == 9 || texte.charCodeAt(texte.length - 1) == 32) {
        texte = texte.substr(0, texte.length - 1);
    }

    return texte;
}

global.replaceUrlParam = function (url, paramName, paramValue) {
    if (url == null || typeof url === 'undefined') {
        url = '';
    } else {
        url = String(url);
    }
    if (paramValue == null) {
        paramValue = '';
    }
    var pattern = new RegExp('\\b(' + paramName + '=).*?(&|#|$)');
    if (url.search(pattern) >= 0) {
        return url.replace(pattern, '$1' + paramValue + '$2');
    }
    url = url.replace(/[?#]$/, '');
    if (!url) {
        return paramName + '=' + paramValue;
    }
    return url + (url.indexOf('?') >= 0 ? '&' : (url.indexOf('=') >= 0 || url.indexOf('&') >= 0 ? '&' : '?')) + paramName + '=' + paramValue;
}

global.nl2br = function (str, is_xhtml) {
    if (typeof str === 'undefined' || str === null) {
        return '';
    }
    var breakTag = (is_xhtml || typeof is_xhtml === 'undefined') ? '<br />' : '<br>';
    return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
}

global.getQueryParams = function (url) {
    const paramArr = url.slice(url.indexOf('?') + 1).split('&');
    const params = {};
    paramArr.map(param => {
        const [key, val] = param.split('=');
        params[key] = decodeURIComponent(val);
    })
    return params;
}

global.urlSerialize = function (obj, prefix) {
    var str = [],
    p;
    for (p in obj) {
        if (obj.hasOwnProperty(p)) {
            var k = prefix ? prefix + "[" + p + "]" : p,
            v = obj[p];
            str.push((v !== null && typeof v === "object") ?
            serialize(v, k) :
            encodeURIComponent(k) + "=" + encodeURIComponent(v));
        }
    }
    return str.join("&");
}

global.isJson = function (string) {
    string = String(string).replace(/&quot;/g, '"');
    try {
        var response = $.parseJSON(string);
        if (typeof response == 'object') {
            return response;
        }
    } catch (e) {

    }
    return false;
}

global.isAssociativeArray = function (array) {
    if (!Array.isArray(array) && typeof array !== "object") return false;
    return !Array.isArray(array) && Object.keys(array).some(key => isNaN(parseInt(key)));
}

global.prepare_text = function (valeur) {
    valeur = "" + valeur;
    //valeur = valeur.replace(/&/g,"%26");
    //valeur = valeur.replace(/\+/g,"%2B");
    valeur = valeur.replace(/\’/g, "'");
    return valeur;
}

global.strip_tags = function (input, allowed) {
    allowed = (((allowed || '') + '').toLowerCase().match(/<[a-z][a-z0-9]*>/g) || []).join('')
    var tags = /<\/?([a-z][a-z0-9]*)\b[^>]*>/gi
    var commentsAndPhpTags = /<!--[\s\S]*?-->|<\?(?:php)?[\s\S]*?\?>/gi
    if (input) {
        return input.replace(commentsAndPhpTags, '').replace(tags, function ($0, $1) {
            return allowed.indexOf('<' + $1.toLowerCase() + '>') > -1 ? $0 : ''
        })
    }
}

global.generateRandomString = function (length) {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let result = '';
    const charactersLength = characters.length;
    for (let i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
}

global.preg_replace = function (array_pattern, array_pattern_replace, my_string) {
    var new_string = String(my_string);
    for (let i = 0; i < array_pattern.length; i++) {
        var reg_exp = RegExp(array_pattern[i], "gi");
        var val_to_replace = array_pattern_replace[i];
        new_string = new_string.replace(reg_exp, val_to_replace);
    }
    return new_string;
}

global.findNumber = function (string) {
    string = String(string).match(/\d+[\.,]?\d*/);
    string = (string && string.length > 0) ? parseFloat(string[0].replace(',', '.')) : 0;
    return string;
}

global.formatFilename = function ($string) {
    return removeSpace(removeSpecialchar(removeAccent(strip_tags($string)))).toLowerCase();
}

global.formatPermalien = function (string) {
    if (string && string != "") {
        return formatFilename(string.replace(/\./g, ""));
    }
    return "";
}

global.removeAccent = function (my_string) {
    var new_string = "";
    var pattern_accent = new Array("é", "è", "ê", "ë", "ç", "à", "â", "ä", "î", "ï", "ù", "ô", "ó", "ö");
    var pattern_replace_accent = new Array("e", "e", "e", "e", "c", "a", "a", "a", "i", "i", "u", "o", "o", "o");
    if (my_string && my_string != "") {
        new_string = preg_replace(pattern_accent, pattern_replace_accent, my_string);
    }
    return new_string;
}

global.removeSpecialchar = function (my_string) {
    var new_string = "";
    var pattern_accent = new Array("&", "%", "!", '"', "=", ",", ";", ":", "'", "{", "}", "<", ">", "@", "¢", "^", "¸", "`", "¨", ",", '\\(', '\\)', '\\[', '\\]');
    var pattern_replace_accent = new Array("et", "pourcent", "", '', "", ",", "", "", "", "", "", "", "", "at", "", "", "", "", "", "", "", "", "", "");
    if (my_string && my_string != "") {
        new_string = preg_replace(pattern_accent, pattern_replace_accent, my_string);
    }
    return new_string;
}

global.removeSpace = function (my_string) {
    var new_string = "";
    var pattern_accent = new Array(" ");
    var pattern_replace_accent = new Array("-");
    if (my_string && my_string != "") {
        new_string = preg_replace(pattern_accent, pattern_replace_accent, my_string);
    }
    return new_string;
}

global.isEmail = function (email) {
    var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    return regex.test(email);
}

global.__ = function(text) {
    return text
}

global.clipboardCopy = function(text, mute) {
    var input = document.body.appendChild(document.createElement("textarea"));
    $(input).css('position', 'fixed');
    input.value = text;
    input.focus();
    input.select();
    document.execCommand('copy');
    input.parentNode.removeChild(input);
}